import React from 'react';
import { ModuleBase } from '@/components';
import { ModuleBaseModel, ImageModel, ModuleBasePropsModel, TaxonomyModel, ExpertModel, LinkModel } from '@/types';
import HalfBanner from './HalfBanner';
import NoBanner from './NoBanner';
import ClassicLetterbox from './ClassicLetterbox';
import FullWidthBanner from './FullWidthBanner';
import classNames from 'classnames';

export type ReportHeroModel = ModuleBaseModel<
  {
    heroType: 'Half Banner' | 'Classic Letterbox' | 'Full Width Banner' | 'No Banner';
    heroImage: {
      desktopImage: ImageModel;
      mobileImage: ImageModel;
    };
    heroEmbedVideo: string;
    heroImageAlignment: 'Left' | 'Right';
    heroBackGroundColour: string;
    thumbnailImage: ImageModel;
    title: string;
    intro: string;
    directory: TaxonomyModel;
    readTime: string;
    publishedDate: Date;
    briefingDate?: Date;
    listenTime?: string;
    authors?: ExpertModel[];
    heroTextColour: 'Light' | 'Dark';
    anchorTextColour: 'White' | 'Black';
    audioDescription: boolean;
    stub?: boolean;
    useHeroImageHeightForEmbedVideo?: boolean;
    breadcrumbs?: LinkModel[];
    heroTextImage?: ImageModel;
  } & ModuleBasePropsModel
>;

const ReportHero = (data: ReportHeroModel) => {
  const {
    props: { heroType },
  } = data;

  return (
    <ModuleBase
      data={{ ...data, props: { ...data.props, backgroundColour: data.props.heroBackGroundColour } }}
      noPadding
      className={classNames('print:mt-0', heroType?.replaceAll(' ', ''))}
    >
      {heroType === 'Half Banner' && <HalfBanner {...data} />}
      {heroType === 'No Banner' && <NoBanner {...data} />}
      {heroType === 'Classic Letterbox' && <ClassicLetterbox {...data} />}
      {heroType === 'Full Width Banner' && <FullWidthBanner {...data} />}
    </ModuleBase>
  );
};

export default ReportHero;
